var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2291 13.0221V16.4944C18.2291 16.9548 18.0462 17.3964 17.7206 17.722C17.395 18.0476 16.9535 18.2305 16.493 18.2305H4.34024C3.87979 18.2305 3.43821 18.0476 3.11262 17.722C2.78704 17.3964 2.60413 16.9548 2.60413 16.4944V13.0221M6.07635 8.68186L10.4166 13.0221M10.4166 13.0221L14.7569 8.68186M10.4166 13.0221V2.60547",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrDownload);
export default __webpack_public_path__ + "static/media/qr-download.c42cb7b56aa03d531a39e9dadc4a46d5.svg";
export { ForwardRef as ReactComponent };